export default function Skeleton() {
  return <div className='homepage-container absolute left-0 top-0 h-[200px] w-full bg-[var(--landing-skeleton-bg)] lg:h-[330px]' data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex h-full w-full items-center justify-between'>
                <div className='h-full w-[9.5%] animate-pulse rounded-l bg-[var(--landing-skeleton-pulse)]' />
                <div className='h-full w-[77%] animate-pulse rounded bg-[var(--landing-skeleton-pulse)]' />
                <div className='h-full w-[9.5%] animate-pulse rounded-r bg-[var(--landing-skeleton-pulse)]' />
            </div>
        </div>;
}